"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullNameClient = void 0;
function getFullNameClient(client) {
    return "".concat(client.first_name, " ").concat(client.second_name ? client.second_name : '', " ").concat(client.first_last_name, " ").concat(client.second_last_name ? client.second_last_name : '', " ");
}
exports.getFullNameClient = getFullNameClient;
